import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Badge } from "react-bootstrap";

import backend from "../../backend";
import CheckBack from "../../components/CheckBack";
import WaitAsync from "../../components/WaitAsync";
import ModalForm from "../../components/ModalForm";
import { formatDate } from "../../utils";

const statusLabel = {
  registered: "Registrada",
  partial: "En Proceso",
  complete: "Completa",
};

const statusVariant = {
  registered: "secondary",
  partial: "warning",
  complete: "success",
};

const CustomerOrder = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const ref = useRef();

  const [co, setCo] = useState();

  const getData = async () => {
    try {
      setCo((await backend.get(`customerOrder/${location.state?._id}`)).data);
    } catch (err) {
      console.log(err);
    }
  };

  const goBack = async () => {
    await new Promise(r => setTimeout(r, 100));
    navigate(-1);
  };

  return (
    <CheckBack to="/customerOrders" onShow={() => ref.current?.show()}>
      <ModalForm
        ref={ref}
        title={co ? `OC #${co.number}` : "OC de Cliente"}
        hideAccept
        hideCancel={false}
        onHide={goBack}
        size="lg"
      >
        <WaitAsync func={getData}>
          {co && (
            <div className="m1-col">
              {/* Header */}
              <div className="flex-row align-items-center mb-2">
                <Badge
                  bg={statusVariant[co.status] || "secondary"}
                  text={co.status === "partial" ? "dark" : undefined}
                  className="me-2"
                >
                  {statusLabel[co.status] || co.status}
                </Badge>
                <span className="text-muted">
                  {co.date ? formatDate(co.date) : "Sin fecha"}
                </span>
              </div>

              {/* Cliente */}
              <div>
                <span className="fw-semibold">Cliente: </span>
                {co.client
                  ? `${co.client.name}${co.client.rut ? ` (${co.client.rut})` : ""}`
                  : "Sin cliente"}
              </div>

              {/* N° OC */}
              {co.clientOCNumber && (
                <div>
                  <span className="fw-semibold">N° OC cliente: </span>
                  {co.clientOCNumber}
                </div>
              )}

              {/* Productos */}
              <div className="fw-semibold mt-2">Productos</div>
              <div
                style={{
                  display: "grid",
                  gap: "8px",
                  gridTemplateColumns: "minmax(0,1fr) 60px 80px 80px", // móvil: la col de pieza puede achicarse
                }}
              >
                <div className="text-muted fw-semibold">Pieza</div>
                <div className="text-muted fw-semibold text-center">Cant.</div>
                <div className="text-muted fw-semibold text-center">Stock</div>
                <div className="text-muted fw-semibold text-center">Fabricar</div>
                {co.items?.map((item, i) => (
                  <React.Fragment key={i}>
                    <div className="align-self-center">
                      {item.piece?.name || "Pieza eliminada"}
                      {item.piece?.sku && (
                        <span className="text-muted ms-1">({item.piece.sku})</span>
                      )}
                    </div>
                    <div className="text-center align-self-center">{item.quantity}</div>
                    <div className="text-center align-self-center">{item.stockAvailable}</div>
                    <div className="text-center align-self-center">{item.toManufacture}</div>
                  </React.Fragment>
                ))}
              </div>

              {/* OTs vinculadas */}
              {co.workOrders?.length > 0 && (
                <>
                  <div className="fw-semibold mt-2">Órdenes de Trabajo vinculadas</div>
                  <div className="m1-col">
                    {co.workOrders.map((wo, i) => (
                      <div key={i} className="flex-row">
                        <i className="bi bi-tools me-2 align-self-center" />
                        <span>
                          OT #{wo.number} — {wo.name || "Sin nombre"}
                        </span>
                        <Badge
                          bg="secondary"
                          className="ms-2 align-self-center"
                        >
                          {wo.status}
                        </Badge>
                      </div>
                    ))}
                  </div>
                </>
              )}

              {/* Observaciones */}
              {co.observations && (
                <div className="mt-2">
                  <span className="fw-semibold">Observaciones: </span>
                  {co.observations}
                </div>
              )}
            </div>
          )}
        </WaitAsync>
      </ModalForm>
    </CheckBack>
  );
};

export default CustomerOrder;
